var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.82713 7.41107C10.1526 7.08563 10.6804 7.08563 11.0058 7.41107L16.0058 12.4111C16.3311 12.7365 16.3311 13.2634 16.0058 13.5888C15.6804 13.9142 15.1526 13.9142 14.8271 13.5888L10.417 9.17865L6.00584 13.5888C5.6804 13.9142 5.15256 13.9142 4.82713 13.5888C4.50212 13.2635 4.50212 12.7364 4.82713 12.4111L9.82713 7.41107Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.e2d43c334b5c24fb29f7791a5fd8d5fb.svg";
export { ForwardRef as ReactComponent };